import { render, staticRenderFns } from "./category-new.vue?vue&type=template&id=2384e8cc"
import script from "./category-new.vue?vue&type=script&lang=js"
export * from "./category-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports